import { render, staticRenderFns } from "./mailbox2.vue?vue&type=template&id=28d40394&scoped=true&"
import script from "./mailbox2.vue?vue&type=script&lang=js&"
export * from "./mailbox2.vue?vue&type=script&lang=js&"
import style0 from "./mailbox2.vue?vue&type=style&index=0&id=28d40394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d40394",
  null
  
)

export default component.exports